import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const EntryDetailSquadChangeModal = ({
  minDate,
  maxDate,
  availableSquads,
  visible,
  onCancel,
  handleSubmit,
  onSubmit,
  entryId,
  onDateChange
}) =>(
  <StandardModal
    title="Change Squad"
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}>
          <ErrorListContainer />
          <Field name="entryId"
            value={entryId}
            type="hidden"
            component={StandardField} />
          <div className="form-group">
            <Field
              name="currentSquadDate"
              type="date"
              minDate={minDate}
              maxDate={maxDate}
              component={StandardField}
              placeholder="Select A Date"
              onCustomChange={onDateChange}
            />
            <Field
              name="currentSquadId"
              component={StandardSelectField}
              options={availableSquads}
              label="Available Squads"
              placeholder="No results found"
              simpleValue
              searchable
            />
          </div>

          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >Cancel</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              ><i className="fa fa-floppy-o" /> {'Save'}</button>
          </div>
        </form>
      </div>
    </StandardModal>
);

EntryDetailSquadChangeModal.propTypes = {
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  availableSquads: PropTypes.arrayOf(PropTypes.object),
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  entryId: PropTypes.string,
  onDateChange: PropTypes.func
};

EntryDetailSquadChangeModal.defaultProps = {
  availableSquads: []
};

export default reduxForm({
  form: 'adminEntryDetailSquadChangeForm'
})(EntryDetailSquadChangeModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailSquadChangeModal.jsx